import { screens } from "./sitemap";

/** Internal screen id for Make a Request (mobile `MAKE_A_REQUEST_SCREEN` parity). */
export const MAKE_A_REQUEST_SCREEN_ID = "screen.makeARequest";

/**
 * Convert internal screen ids (`screen.inAnEmergency`) to URL path segments (`in-an-emergency`)
 * using camelCase → kebab-case on the portion after `screen.`.
 */
export function screenIdToUrlSlug(screenId: string): string {
  const m = screenId.match(/^screen\.(.+)$/);
  const tail = m ? m[1]! : screenId;
  return camelToKebab(tail);
}

function camelToKebab(s: string): string {
  return s
    .replace(/([a-z0-9])([A-Z])/g, "$1-$2")
    .replace(/([A-Z])([A-Z][a-z])/g, "$1-$2")
    .replace(/_/g, "-")
    .toLowerCase();
}

/** Reverse lookup: URL slug → internal `screen.*` id (built from `screens` keys). */
function buildSlugToScreenMap(): Record<string, string> {
  const map: Record<string, string> = {};
  for (const id of Object.keys(screens)) {
    const slug = screenIdToUrlSlug(id);
    const existing = map[slug];
    if (existing && existing !== id) {
      throw new Error(
        `screenUrlSlugs: duplicate slug "${slug}" for "${existing}" and "${id}"`,
      );
    }
    map[slug] = id;
  }
  return map;
}

const SLUG_TO_SCREEN: Record<string, string> = buildSlugToScreenMap();

export function urlSlugToScreenId(slug: string): string | null {
  return SLUG_TO_SCREEN[slug] ?? null;
}
